var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.6 499.6",
    style: {
      enableBackground: "new 0 0 499.6 499.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#063F66"
    },
    cx: 249.6,
    cy: 250,
    r: 249.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022730"
    },
    d: "M72.8,73.2c97.6-97.6,256-97.6,353.6,0s97.6,256,0,353.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DCF9F6"
    },
    cx: 133.6,
    cy: 425.2,
    rx: 2.4,
    ry: 21.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DCF9F6"
    },
    cx: 133.6,
    cy: 426,
    rx: 21.6,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7054 -0.7088 0.7088 0.7054 18.6212 346.765)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 426.474,
    cy: 150.981,
    rx: 21.6,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7054 0.7088 -0.7088 0.7054 232.7671 -257.5539)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 426.225,
    cy: 151.245,
    rx: 21.6,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DCF9F6"
    },
    cx: 366.4,
    cy: 84.4,
    rx: 0.8,
    ry: 9.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DCF9F6"
    },
    cx: 366.4,
    cy: 84.4,
    rx: 9.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7107 -0.7035 0.7035 -0.7107 232.771 301.5383)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 178.387,
    cy: 102.907,
    rx: 10.4,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7107 -0.7035 0.7035 0.7107 -20.6411 155.2913)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 178.491,
    cy: 102.742,
    rx: 10.4,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7089 -0.7053 0.7053 -0.7089 -92.7171 692.6153)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 96.571,
    cy: 365.441,
    rx: 10.4,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7089 -0.7053 0.7053 0.7089 -229.2989 174.8202)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 97.139,
    cy: 365.198,
    rx: 10.4,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6999 -0.7143 0.7143 0.6999 37.5702 239.1812)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 303.395,
    cy: 74.884,
    rx: 4.8,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6999 0.7143 -0.7143 0.6999 144.8238 -194.2028)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 303.501,
    cy: 75.23,
    rx: 4.8,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6998 -0.7144 0.7144 0.6998 -254.4496 288.0746)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 215.498,
    cy: 446.756,
    rx: 4.8,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6998 0.7144 -0.7144 0.6998 384.246 -19.8844)",
    style: {
      fill: "#DCF9F6"
    },
    cx: 215.78,
    cy: 447.195,
    rx: 4.8,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DCF9F6"
    },
    cx: 249.6,
    cy: 250,
    r: 160
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95BFB9"
    },
    d: "M385.6,250c0,88-48,160-136,160s-160-72-160-160s72-160,160-160S385.6,162,385.6,250z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 138.4,
    cy: 165.2,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 124.8,
    cy: 201.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 189.6,
    cy: 222,
    r: 29.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 202.4,
    cy: 157.2,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 257.6,
    cy: 153.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 278.4,
    cy: 126,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 201.6,
    cy: 127.6,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 233.6,
    cy: 114,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 270.4,
    cy: 206,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 318.4,
    cy: 202,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 328.8,
    cy: 156.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 300.8,
    cy: 285.2,
    r: 17.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 156,
    cy: 295.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 213.6,
    cy: 271.6,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 241.6,
    cy: 331.6,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 124.8,
    cy: 254.8,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 267.2,
    cy: 250.8,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 344,
    cy: 254,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 174.4,
    cy: 339.6,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 193.6,
    cy: 305.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 292.8,
    cy: 342.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 241.6,
    cy: 369.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 201.6,
    cy: 365.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 332.8,
    cy: 328.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 284,
    cy: 375.6,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 245.6,
    cy: 289.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 353.6,
    cy: 300.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 134.4,
    cy: 323.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78A8A0"
    },
    cx: 309.6,
    cy: 241.2,
    r: 7.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon_icon.06ad928672b0c1aa6da2569ee595656e.svg";
export { ForwardRef as ReactComponent };